import { type FC, useEffect, useMemo, useState } from "react";
import { Loading } from "@clientFrontend/features/scout/components/Loading";
import { Presentation } from "./Presentation";
import { useScoutUserCassettes } from "./useScoutUserCassettes";
import { useMultiScoutInfo } from "./useMultiScoutInfo";

type Props = {
  multiScoutInfoUrls: {
    addUrl: string;
    delUrl: string;
    addArrayUrl: string;
    delArrayUrl: string;
    resetUrl: string;
  };
  fetchUrl: string;
  scoutUrl?: string;
  checkedUserCount?: number;
  scoutCount?: number;
  showSubmitButton?: boolean;
  isShowCheckbox?: boolean;
  isShadow?: boolean;
  isShowScoutNavigation: boolean;
  isHiddenInitialValueArray?: boolean[];
  hiddenScoutUrl?: string;
  fetchParams: Record<string, unknown>;
  autoSelectAvailableRole?: boolean;
};

export const ScoutUserCassettes: FC<Props> = ({
  multiScoutInfoUrls: { addUrl, delUrl, addArrayUrl, delArrayUrl, resetUrl },
  fetchUrl,
  scoutUrl,
  checkedUserCount,
  scoutCount,
  showSubmitButton = true,
  isShowCheckbox,
  isShadow = true,
  isShowScoutNavigation,
  isHiddenInitialValueArray,
  hiddenScoutUrl,
  fetchParams,
  autoSelectAvailableRole,
}) => {
  const userInformationList = useScoutUserCassettes(fetchUrl, fetchParams);
  const userStatus = useMemo(
    () => userInformationList?.flatMap((item) => (item.multiScoutInfo ? item.multiScoutInfo : [])),
    [userInformationList],
  );
  const isMultiScout = showSubmitButton && !!(userStatus && userStatus.length > 0);
  const [isDisabled, setIsDisabled] = useState(false);
  const [userStatusArray, setUserStatusArray] = useState(userStatus);
  useEffect(() => {
    setUserStatusArray(userStatus);
  }, [userStatus]);

  // チェック状況をサーバに保存している間は送信ボタンを押しても送信画面に遷移しないようにする
  // 送信ボタンはAタグなのでdisabledにするだけでなくevent.preventDefault()する必要がある
  const handleClickLink = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (!isDisabled) return;
    event.preventDefault();
  };

  const { isMultiScoutChecked, updateSelectedUser, updateAllUser, resetAllUser, scoutUserCount } =
    useMultiScoutInfo({
      addUrl,
      delUrl,
      addArrayUrl,
      delArrayUrl,
      resetUrl,
      checkedUserCount: checkedUserCount || 0,
      countOfDefaultCheckedUserOnPage: userStatus?.filter((item) => item.isChecked).length || 0,
      userStatusArray: userStatusArray || [],
      setUserStatusArray,
      setIsDisabled,
    });

  if (!userInformationList)
    return (
      // TODO: ローディング要素のデザインコンポーネントが出来次第
      // 汎用ローディングコンポーネントを作成して置き換える
      <Loading isShadow={isShadow} />
    );

  return (
    <Presentation
      userInformationArray={userInformationList}
      userStatusArray={userStatusArray}
      isMultiScout={isMultiScout}
      updateSelectedUser={updateSelectedUser}
      isMultiScoutChecked={isMultiScoutChecked}
      updateAllUser={updateAllUser}
      resetAllUser={resetAllUser}
      scoutUrl={scoutUrl}
      checkedUserCount={scoutUserCount}
      scoutCount={scoutCount}
      isShowCheckbox={isShowCheckbox}
      isDisabled={isDisabled}
      isShadow={isShadow}
      isShowScoutNavigation={isShowScoutNavigation}
      handleClickLink={handleClickLink}
      // 求職者をおすすめ一覧から非表示にする機能で使用
      isHiddenInitialValueArray={isHiddenInitialValueArray}
      hiddenScoutUrl={hiddenScoutUrl}
      autoSelectAvailableRole={autoSelectAvailableRole}
    />
  );
};
